import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import EnergyTrade from 'Assets/Images/energyTrade.png'
const IntegratedEnergyGateway = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    const content = {
        fa: {
            description: (
                <>
                    <strong className="fw-bold">
                        سامانه درگاه یکپارچه مبادلات انرژی بورس انرژی ایران
                    </strong>{" "}
                    بستری برای ثبت، مدیریت و تبادل داده‌های معاملاتی انواع حامل‌های انرژی
                    است که با هدف ایجاد یکپارچگی و کارایی در بازارهای انرژی کشور طراحی
                    شده است. در این سامانه، قراردادهای دوجانبه بین تولیدکنندگان،
                    خرده‌فروشان و مصرف‌کنندگان ثبت می‌شود و اطلاعات آن برای اعمال و صدور
                    قبض به شرکت‌های مالک شبکه ارسال می‌گردد. همچنین، امکان مدیریت ابزارها
                    و گواهی‌های مرتبط با انرژی از جمله گواهی برق تجدیدپذیر و سایر
                    کالاهای انرژی‌محور در آینده از طریق این درگاه فراهم خواهد بود.
                </>
            ),
        },

        en: {
            description: (
                <>
                    <strong className="fw-bold">
                        The Integrated Energy Trading Gateway System of Iran Energy Exchange
                    </strong>{" "}
                    is a platform designed for the registration, management, and exchange
                    of transactional data related to various energy carriers, with the
                    aim of enhancing integration and efficiency in the country’s energy
                    markets. Within this system, bilateral contracts between producers,
                    retailers, and consumers are registered, and the related information
                    is transmitted to network-owning companies for billing and settlement
                    purposes. Additionally, the management of energy-related instruments
                    and certificates, including renewable electricity certificates and
                    other energy-based commodities, will be made available through this
                    gateway in the future.
                </>
            ),
        },

        ar: {
            description: (
                <>
                    <strong className="fw-bold">
                        نظام البوابة الموحدة لتداول الطاقة في بورصة الطاقة الإيرانية
                    </strong>{" "}
                    هو منصة مخصصة لتسجيل وإدارة وتبادل بيانات المعاملات الخاصة بمختلف
                    حوامل الطاقة، وقد تم تصميمه بهدف تحقيق التكامل ورفع كفاءة أسواق
                    الطاقة في البلاد. في هذا النظام، يتم تسجيل العقود الثنائية بين
                    المنتجين وتجار التجزئة والمستهلكين، ويتم إرسال معلوماتها إلى
                    الشركات المالكة للشبكات لأغراض الفوترة وإصدار الفواتير. كما ستتوفر
                    مستقبلاً إمكانية إدارة الأدوات والشهادات المرتبطة بالطاقة، بما في
                    ذلك شهادات الكهرباء المتجددة وغيرها من السلع المعتمدة على الطاقة،
                    من خلال هذه البوابة.
                </>
            ),
        },
    };


    const { description } = content[currentLang] || content.fa; // fallback to fa

    return (
        <div className="megaMenuContent">
            <div className="row justify-content-between h-100 energyTradeBg">
                <div className="col-7">
                    <p className="text-justify">{description}</p>
                </div>
                <div className="col-12 d-flex align-items-end">
                    <a href="https://otc.iee.ir" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                        {t("loginToSystem")}
                        <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                            <ChevronLeft width={15} height={10} />
                        </span>
                    </a>

                </div>
            </div>
        </div>
    );
};

export default IntegratedEnergyGateway;
